import UrlPattern from 'url-pattern';
import { UrlMappingsKeys } from '@wix/url-mapper-utils';
import { ALL_ROUTES, ROUTE_CATEGORY, ROUTE_CATEGORY_CREATE_POST, ROUTE_CATEGORY_CREATE_QUESTION, ROUTE_POST, ROUTE_POST_EDIT, } from '../constants';
export var getCustomRoute = function (url) {
    for (var key in ALL_ROUTES) {
        var forumRoute = ALL_ROUTES[key];
        var pattern = new UrlPattern(forumRoute);
        var params = pattern.match(url);
        if (params) {
            var customRouteKey = mapRouteToCustomKey(forumRoute, params);
            return {
                customRouteKey: customRouteKey,
                params: params,
            };
        }
    }
    return {};
};
export var buildRoutesMap = function () {
    var _a;
    var page = '**page**';
    var deepLinkData = '**deepLinkData**';
    var categorySlug = '**categorySlug**';
    var slug = '**categorySlug**';
    var postSlug = '**postSlug**';
    return _a = {},
        _a[UrlMappingsKeys.FORUM_POST_PAGINATION_AND_DEEP_LINK_DATA] = {
            postSlug: postSlug,
            categorySlug: categorySlug,
            page: page,
            deepLinkData: deepLinkData,
        },
        _a[UrlMappingsKeys.FORUM_POST_DEEP_LINK_DATA] = { postSlug: postSlug, categorySlug: categorySlug, deepLinkData: deepLinkData },
        _a[UrlMappingsKeys.FORUM_POST_PAGINATION] = { postSlug: postSlug, categorySlug: categorySlug, page: page },
        _a[UrlMappingsKeys.FORUM_POST] = { postSlug: postSlug, categorySlug: categorySlug },
        _a[UrlMappingsKeys.FORUM_POST_EDIT] = { postSlug: postSlug, categorySlug: categorySlug },
        _a[UrlMappingsKeys.FORUM_CATEGORY_PAGINATION] = { slug: slug, page: page },
        _a[UrlMappingsKeys.FORUM_CATEGORY] = { slug: slug },
        _a[UrlMappingsKeys.FORUM_CATEGORY_CREATE_POST] = { slug: slug },
        _a[UrlMappingsKeys.FORUM_CATEGORY_CREATE_QUESTION] = { slug: slug },
        _a;
};
var mapRouteToCustomKey = function (route, params) {
    switch (route) {
        case ROUTE_POST:
            if (params.page && params.deepLinkData) {
                return UrlMappingsKeys.FORUM_POST_PAGINATION_AND_DEEP_LINK_DATA;
            }
            else if (params.deepLinkData) {
                return UrlMappingsKeys.FORUM_POST_DEEP_LINK_DATA;
            }
            else if (params.page) {
                return UrlMappingsKeys.FORUM_POST_PAGINATION;
            }
            else {
                return UrlMappingsKeys.FORUM_POST;
            }
        case ROUTE_POST_EDIT:
            return UrlMappingsKeys.FORUM_POST_EDIT;
        case ROUTE_CATEGORY:
            return params.page
                ? UrlMappingsKeys.FORUM_CATEGORY_PAGINATION
                : UrlMappingsKeys.FORUM_CATEGORY;
        case ROUTE_CATEGORY_CREATE_POST:
            return UrlMappingsKeys.FORUM_CATEGORY_CREATE_POST;
        case ROUTE_CATEGORY_CREATE_QUESTION:
            return UrlMappingsKeys.FORUM_CATEGORY_CREATE_QUESTION;
        default:
            return;
    }
};
export var buildCustomUrl = function (customRoutes, key, routeParams, removeSubstr) {
    if (routeParams === void 0) { routeParams = {}; }
    var route = customRoutes[key] || '';
    for (var param in routeParams) {
        route = route.replace("**".concat(param, "**"), routeParams[param]);
    }
    return removeSubstr ? route.replace(removeSubstr, '') : route;
};
//# sourceMappingURL=custom-routing-service.js.map